import { createFileRoute, notFound } from '@tanstack/react-router'
import { NetworkSiteDetail } from '@/components/sensnet/networkSites/NetworkSiteDetail'

export const Route = createFileRoute('/sensnet/network-sites/$siteNumber')({
  staticData: {
    title: 'Network Site Profile',
    isSecured: true,
  },
  parseParams: (params) => ({
    siteNumber: Number(params.siteNumber),
  }),
  beforeLoad: ({ params }) => {
    if (isNaN(params.siteNumber)) throw notFound()
  },
  component: NetworkSiteProfilePage,
})

function NetworkSiteProfilePage() {
  const { siteNumber } = Route.useParams()
  return (
    <div className="p-6">
      <NetworkSiteDetail siteNumber={siteNumber} />
    </div>
  )
}
